<template>
  <div class="contents mst_syounin_groups">
    <h2>承認グループ新規登録</h2>

    <div class="container">
      <template v-if="isLoading">
        <loading :isLoading="isLoading" :message="'データ読み込み中...'"></loading>
      </template>

      <template v-else>
        <section class="group-name">
          <h3>グループ名と承認種別の設定</h3>
          <p>
            グループ名は管理上必要な名称を指します。わかりやすい名前をつけてください。<br>
            承認種別はグループで取り扱う業務を指します。
          </p>

          <div class="input-area">
            <div class="form-item">
              <label>グループ名</label>
              <input-text type="text" max-length="128" v-model="groupName"></input-text>
            </div>

            <div class="form-item" v-if="syouninGroupOptions">
              <label>承認種別</label>
              <select-box :options="syouninGroupOptions.syounin_types" v-model="syouninType" @update:modelValue="changeSyouninType"></select-box>
            </div>
          </div>
        </section>

        <section class="syouninsya">
          <h3>承認者／確認者の設定</h3>
          <p>
            このグループにおける承認者または確認者を選択して下さい。<br>
            承認者は承認の流れにおいて承認／否認を行うことができます。<br>
            確認者はそれらは行えませんが内容の確認を行うことができます。
          </p>

          <div class="selecter">
            <div class="search-users">
              <h4>ユーザーの選択</h4>
              <form @submit.prevent="search">
                <!-- <p style="color:red">TODO: 検索条件：仮：検討中。現在は全ユーザーを取得</p> -->
                <div class="filter">
                  <label>フィルター：</label>
                  <input v-model="filterCondition" type="text">
                </div>

                <!-- <input-text v-model="searchCondition" type="text"></input-text>
                <button type="button" class="btn primary" @click="search">
                <i class="fa-solid fa-magnifying-glass"></i>ユーザーを検索する
              </button> -->
              </form>

              <div class="search-result">
                <scroll-table max-height="calc(70vh - 340px)">
                  <table>
                    <thead>
                      <tr>
                        <th>[社員番号] 名前</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in filteredUsers" :key="index" @click="switchSelectStatus(row)"
                        :class="{ selected: row.is_select }">
                        <td class="name"><span v-if="row.staff_code">[{{ row.staff_code }}]</span>{{ row.staff_name }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </scroll-table>
              </div>
            </div>

            <div class="selected-users">
              <h4>選択済みの承認者・確認者</h4>
              <scroll-table max-height="calc(70vh - 190px)" v-if="selectedUserList.length > 0">
                <table>
                  <thead>
                    <tr>
                      <th class="order">承認<br>順序</th>
                      <th class="name">ユーザー名</th>
                      <th class="type">種別</th>
                      <th>削除</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in selectedUserList" :key="row.user_id">
                      <template v-if="!row.is_delete">
                        <td class="bureau">{{ index + 1 }}</td>
                        <td class="office">{{ row.staff_name }}</td>
                        <td>
                          <input-radio :options="radioOptions" v-model="row.is_syounin"></input-radio>
                        </td>
                        <td class="delete">
                          <i class="fa-solid fa-delete-left" @click="row.is_select = false"></i>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </scroll-table>
              <p v-else>リストからユーザーを選択してください</p>
            </div>
          </div>
        </section>

        <section class="syouninsya">
          <h3>所属するスタッフの設定</h3>
          <p>
            このグループに所属し、申請等の承認を受けるスタッフを選択して下さい。<br>
            *** ユーザーを再検索すると、このリストはクリアされます。 ***
            
          </p>

          <div class="selecter">
            <div class="search-users">
              <h4>所属するスタッフの選択</h4>
              <form @submit.prevent="search">
                <!-- <p style="color:red">TODO: 検索条件：仮：検討中。現在は全ユーザーを取得</p> -->
                <div>
                  <div>
                  <label>検索した結果をユーザー名でフィルターします：</label>
                  </div>
                  <div>
                    <input v-model="stafffilterCondition" type="text">
                  </div>
                </div>

                <!-- <input-text v-model="searchCondition" type="text"></input-text> -->
                <button type="button" class="btn primary" @click="searchStaff">
                <i class="fa-solid fa-magnifying-glass"></i>スタッフを再検索する
              </button>
              </form>

              <div class="search-result">
                <scroll-table max-height="calc(70vh - 340px)">
                  <table>
                    <thead>
                      <tr>
                        <th>[社員番号] 名前</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in stafffilteredUsers" :key="index" @click="switchSelectStaffStatus(row)"
                        :class="{ selected: row.is_select }">
                        <td class="name"><span v-if="row.staff_code">[{{ row.staff_code }}]</span>{{ row.staff_name }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </scroll-table>
              </div>
            </div>

            <div class="selected-users">
              <h4>選択済みの所属するスタッフ</h4>
              <scroll-table max-height="calc(70vh - 190px)" v-if="selectedStaffUserList.length > 0">
                <table>
                  <thead>
                    <tr>
                      <th class="name">ユーザー名</th>
                      <th>削除</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in selectedStaffUserList" :key="row.user_id">
                      <template v-if="!row.is_delete">
                        <td class="office">{{ row.staff_name }}</td>
                        <td class="delete">
                          <i class="fa-solid fa-delete-left" @click="row.is_select = false"></i>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </scroll-table>
              <p v-else>リストからユーザーを選択してください</p>
            </div>
          </div>

        </section>
      </template>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.MST_SYOUNIN_GROUP_SEARCH,
        }">戻る
        </router-link>
      </p>
      <p class="btn-temporary-save">
        <button type="button" @click="create" :disabled="isLoading || isCreating">
          <template v-if="isCreating">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>承認グループ登録中…
          </template>
          <template v-else>
            <i class="fa-solid fa-floppy-disk"></i>承認グループ登録
          </template>
        </button>
      </p>
    </div>

  </div>
</template>

<script lang="ts">

import { ref, computed, defineComponent, onMounted, Ref } from 'vue'
import { useInit } from '@/composable/master/syounin_group/init';
import OptionConst from '@/const/Option';
import { RouterConst } from '@/const/Router'
import { DialogService } from '@/service/DialogService';
import { SweetAlertResult } from 'sweetalert2';
import { useSyouninGroupOptions } from '@/composable/master/syounin_group/syounin_group_options';
import { useSyouninGroup } from '@/composable/master/syounin_group/syounin_group';
import { SelectableSyouninUser, SelectableGroupUser } from '@/types/SyouninGroup';
import { BaseOptionWithoutCode } from "@/types/Option";

export default defineComponent({
  setup() {
    // 初期化
    const { syouninGroupOptions, getAllSyouninGroupOptions } = useSyouninGroupOptions()
    const { getSelectableSyouninUserList, selectableSyouninUserList, isCreating, createSyouninGroup, selectableGroupUserList, getSelectableSyouninGroupUserList } = useSyouninGroup()

    // 承認者・確認者のラジオオプション
    const radioOptions = [{ 'val': true, 'label': '承認者' }, { 'val': false, 'label': '確認のみ' }];

    let filterCondition = ref('');

    let stafffilterCondition = ref('');

    // ユーザーを検索します
    const search = async () => {
      await getSelectableSyouninUserList();
    };

    const isLoading = ref(false)
    onMounted(async () => {
      isLoading.value = true
      await getAllSyouninGroupOptions();
      await search();
      isLoading.value = false
    })

    // フィルタ変数
    const filter = ref('')

    const groupName: Ref<string> = ref('')
    const syouninType: Ref<number | null> = ref(null)
    
    // 承認者グループを新規登録します
    const create = async () => {
      // 入力チェック
      if (!syouninType.value || !groupName.value) {
        DialogService.error({
          text: '承認種別と承認グループ名を入力してください'
        });
        return;
      };

      const selectedUserList = selectableSyouninUserList.value.filter(user => user.is_select);
      const hasSyouninsya = selectedUserList.find(user => user.is_syounin)

      // 入力チェック
      if (selectedUserList.length === 0 || !hasSyouninsya) {
        DialogService.error({
          text: '承認者を選択してください'
        });
        return;
      };

      const dialogResult = await DialogService.question({
        text: '承認グループを登録しますか？',
        showCancelButton: true,
        confirmButtonText: '登録します',
        cancelButtonText: 'キャンセル',
      })
      
      if (!dialogResult.isConfirmed) {
        return
      }

      let result = await createSyouninGroup(syouninType.value, groupName.value, selectedUserList, selectedStaffUserList.value);

      if(result){
        // スタッフは同一承認種別で一つのグループにしか所属しない制限にしているため
        // 選択されたグループに所属可能なスタッフをクリアする
        // selectableGroupUserList.value = [];
        // stafffilterCondition.value = '';
      }
    }

    const filteredUsers = computed(() => {
      if (filterCondition.value) {
        return selectableSyouninUserList.value.filter(user => user.staff_name.match(filterCondition.value))
      } else {
        return selectableSyouninUserList.value
      }
    })

    const switchSelectStatus = (user: SelectableSyouninUser) => {
      user.is_select = !user.is_select
    }

    const selectedUserList = computed(()=>{
      return selectableSyouninUserList.value.filter(user => user.is_select)
    })

    // グループに所属可能なスタッフを検索します
    const searchStaff = async () => {
      // 入力チェック
      if (!syouninType.value) {
        DialogService.error({
          text: '承認種別を入力してください'
        });
        return;
      };
      selectableGroupUserList.value = [];
      stafffilterCondition.value = '';
      await getSelectableSyouninGroupUserList(syouninType.value);
    };

    // フィルタ文字列でフィルタしたグループに所属可能なスタッフ
    const stafffilteredUsers = computed(() => {
      if (stafffilterCondition.value) {
        return selectableGroupUserList.value.filter(user => user.staff_name.match(stafffilterCondition.value))
      } else {
        return selectableGroupUserList.value
      }
    })

    // 選択されたグループに所属可能なスタッフ
    const selectedStaffUserList = computed(()=>{
      return selectableGroupUserList.value.filter(user => user.is_select)
    })

    // 承認種別を変更した際に実行
    const changeSyouninType = async (val: BaseOptionWithoutCode) => {

      // スタッフは同一承認種別で一つのグループにしか所属しない制限にしているため
      // 選択されたグループに所属可能なスタッフをクリア
      // selectableGroupUserList.value = [];
      // stafffilterCondition.value = '';
    };

    const switchSelectStaffStatus = (user: SelectableGroupUser) => {
      user.is_select = !user.is_select
    }

    return {
      groupName,
      syouninType,
      syouninGroupOptions,
      isLoading,
      isCreating,
      create,
      search,
      selectableSyouninUserList,
      OptionConst,
      RouterConst,
      filter,
      selectedUserList,
      radioOptions,
      createSyouninGroup,
      filterCondition,
      filteredUsers,
      switchSelectStatus,
      selectableGroupUserList,
      getSelectableSyouninGroupUserList,
      searchStaff,
      stafffilterCondition,
      stafffilteredUsers,
      selectedStaffUserList,
      changeSyouninType,
      switchSelectStaffStatus,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/syounin_group_create.scss";
</style>
